<template>
    <div class="span4">
        <p style="margin: 0 auto;">
            <b>{{ resource["title"] }}</b>
        </p>
        <LoaderPiechart v-if="loading" />
        <div
            v-show="!loading"
            id="sub-chart3"
            style="width: 90%; height: 250px; overflow-y: inherit;"
        ></div>
    </div>
</template>

<script>
import axios from "axios";
import LoaderPiechart from "@/components/elements/loader-piechart.vue";

export default {
    components: {
        LoaderPiechart
    },
    data() {
        return {
            resource: "",
            params: "",
            code: "",
            loading: true
        };
    },
    mounted() {
        if (window.location.pathname == "/apps/billing/summary") {
            this.loading = false;
        }
        this.init();
    },
    methods: {
        init() {
            let self = this;
            axios
                .get(process.env.BARRACUDA + "report/billing/payment_by_type")
                .then(function (response) {
                    self.resource = response.data.response.resources;
                    self.code = response.data.response.message["code"];
                    self.params = {
                        results: response.data.response.resources["results"],
                        xaxis: response.data.response.resources["xaxis"]
                    };
                    if (self.code == "200") {
                        self.render_graph(self.params);
                    }
                });
        },
        render_graph(params) {
            var data = params.results;

            var options = {
                series: {
                    pie: {
                        show: true,
                        radius: 1,
                        label: {
                            show: false
                        }
                    }
                },
                grid: {
                    hoverable: true
                },
                tooltip: true,
                tooltipOpts: {
                    cssClass: "flotTip",
                    content: "%p.0%, %s",
                    shifts: {
                        x: 20,
                        y: 0
                    },
                    defaultTheme: false
                },
                legend: {
                    show: false
                }
            };

            function labelFormatter(label, series) {
                return (
                    "<div style='position:absolute;top: 36px;right: 19px; font-size:8pt; text-align:center; padding:2px; color:white;'>" +
                    label +
                    "<br/>" +
                    series.data[0][1] +
                    " (" +
                    Math.round(series.percent) +
                    "%)</div>"
                );
            }

            $.plot($("#sub-chart3"), data, options);
            this.loading = false;
            $(window).resize(function () {
                if (
                    window.location.pathname == "/view/billing/dashboard" ||
                    window.location.pathname == "/apps/billing/summary"
                ) {
                    $.plot($("#sub-chart3"), data, options);
                }
            });
        }
    }
};
</script>
<style>
#flotTip {
    padding: 3px 5px;
    background-color: #000;
    z-index: 100;
    color: #fff;
    opacity: 0.8;
    filter: alpha(opacity=85);
}
</style>
